import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { ImpalaObjectDataset } from 'app/model/dataset/impala.dataset';
import { Metamodel } from 'app/model/base/model';
import { ImpalaLinkedService } from 'app/model/linkedservice/impala.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { ColumnType, defaultSupportedColumnTypes } from 'app/shared/utils/column-type.util';
import { GlobalVariables } from 'app/services/globals';
import { batchSizeV2Metadata, queryTimeoutV2Metadata } from '../consts/metadata-consts';

export const impalaObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(ImpalaObjectDataset).name,
    displayName: stringResources.Impala_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(ImpalaLinkedService).name],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: format(
        stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
         stringResources.VersionLabel.toLocaleLowerCase()
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-impala',
    icon: {
        className: 'svg-i-100x100-apache_impala'
    },
    isFirstClass: true,
    supportDataTypes: defaultSupportedColumnTypes.concat(ColumnType.SByte),
    supportCreatedAsV2: true,
    splitTablePath: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['Database'],
    copySourceControls: [
        GlobalVariables.enableImpalaV2BatchSize
            ? {
                  ...batchSizeV2Metadata,
                  child: {
                      ...batchSizeV2Metadata.child,
                      description: format(
                          stringResources.BatchSize_Description_Template,
                          stringResources.Impala_DisplayText
                      )
                  },
                  hide: '{ owner && owner.sourceDataset && owner.sourceDataset.linkedService && owner.sourceDataset.linkedService.version !== "v2" }'
              }
            : undefined,
        GlobalVariables.enableImpalaV2QueryTimeout
            ? {
                  ...queryTimeoutV2Metadata,
                  hide: '{ owner && owner.sourceDataset && owner.sourceDataset.linkedService && owner.sourceDataset.linkedService.version !== "v2" }'
              }
            : undefined
    ].filter(Boolean)
};
